import * as angular from "angular";
import * as _ from "lodash";
import {ConfirmDialogService} from "../../commons/services/confirm-dialog.service";

export class SitesDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private splitConstants, private uploadFile, private $log, private confirmDialogService: ConfirmDialogService) {
  }

  createSite(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/set-site-dialog.html').default,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.logoStatus = 'idle';
        $scope.header = 'Create New Site';

        $scope.site = {
          name: undefined,
          country: 'US',
          enabled: true,
          localeCode: undefined,
          logoUrl: undefined,
          address: {}
        };

        $scope.countries = self.splitConstants.countries;
        $scope.languages = self.splitConstants.languages;

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onLogoUpload = ($files) => {
          $scope.logoStatus = 'upload';
          self.uploadFile($files[0])
            .then((response) => {
              $scope.logoStatus = 'complete';
              $scope.site.logoUrl = _.get(response, 'data.url');
            })
            .catch((error) => {
              if (error) {
                $scope.logoStatus = 'idle';
                $scope.site.logoUrl = undefined;
                self.$log.error('Failed to upload file, agentDialogService@uploadDocuments@uploadMvr', error);
              }
            })
        }

        $scope.onAddressChange = (address) => {
          $scope.site.address = address;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.site);
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editSite(event, site) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/set-site-dialog.html').default,
      controller: function ($scope) {

        $scope.site = angular.copy(site);

        $scope.loading = false;
        $scope.logoStatus = site.logoUrl ? 'complete' : 'idle';
        $scope.countries = self.splitConstants.countries;
        $scope.languages = self.splitConstants.languages;

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onLogoUpload = ($files) => {
          $scope.logoStatus = 'upload';
          self.uploadFile($files[0])
            .then((response) => {
              $scope.logoStatus = 'complete';
              $scope.site.logoUrl = _.get(response, 'data.url');
            })
            .catch((error) => {
              if (error) {
                $scope.logoStatus = 'idle';
                $scope.site.logoUrl = undefined;
                self.$log.error('Failed to upload file, agentDialogService@uploadDocuments@uploadMvr', error);
              }
            })
        }

        $scope.onAddressChange = (address) => {
          $scope.site.address = address;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.site);
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }
}

angular
  .module('bringoz.admin.sites')
  .service('sitesDialogService', SitesDialogService);
